import React, { useContext, useEffect, useState } from 'react'
import { CircularProgress, makeStyles } from '@material-ui/core'
import { CoreContext } from '../../../../core/context/CoreContext'
import { BasketContext } from '../../../../core/context/BasketContext'
import DetailedItemTemplate from './DetailedItemTemplate'

const useStyles = makeStyles(() => ({
  loader: {
    marginTop: 100,
    textAlign: 'center',
  },
}))

export default function DetailedProductView(props) {
  const itemId = props.match.params.id
  const classes = useStyles()
  const core = useContext(CoreContext)
  const basket = useContext(BasketContext)

  const [isLoading, setIsLoading] = useState(true)
  const [itemDetails, setItemDetails] = useState({
    productNo: '',
    description: '',
    colli: '',
    brandNo: '',
    designCollectionNo: '',
    functionGroupNo: '',
    inventoryQuantity: '',
    multiplesQuantity: '',
    orderMultiple: '',
    width: '',
    height: '',
    depth: '',
    inriverId: 0,
    defaultPriceDto: {
      priceValidFromQuantity: 0,
      grossPrice: 0,
      netPrice: 0,
      discountPercentage: 0,
    },
    priceDtos: [
      {
        priceValidFromQuantity: 0,
        grossPrice: 0,
        netPrice: 0,
        discountPercentage: 0,
      },
    ],
    dimension: [
      {
        depthCm: 0,
        widthCm: 0,
        heightCm: 0,
        volumeL: 0,
        diameterCm: 0,
        grossWeightKg: 0,
      },
    ],
    giftBox: [
      {
        depthCm: 0,
        widthCm: 0,
        heightCm: 0,
        noOfGiftBoxesPerPallet: 0,
      },
    ],
    brownBox: [
      {
        boxEanCode: 0,
        depthCm: 0,
        widthCm: 0,
        heightCm: 0,
        numberOfItemsInBox: 0,
      },
    ],
  })

  const currentDateValue = () => {
    if (basket.basket.requestedShippingDate) {
      return new Date(basket.basket.requestedShippingDate)
    }

    const date = new Date()
    return new Date(date.setDate(date.getDate() + 1))
  }

  function load() {
    const date = currentDateValue()

    const formattedDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1,
    ).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T00:00:00`

    return core.dataStore
      .getProductById(
        core.user.selectedCustomer.accountNo,
        itemId,
        core.user.languageCode,
        core.user.userId,
        formattedDate
      )
      .then((res) => {
        if (res.status === 200) {
          setItemDetails(res.data)
          setIsLoading(false)
        } else {
          core.snackbar('warning', res.statusText)
        }
      })
      .catch((e) => {
        core.snackbar('warning', e.toString())
        setIsLoading(false)
      })
  }

  useEffect(() => {
    if (core.user.selectedCustomer.accountNo) {
      load()
    }
  }, [core.user.userId, core.user.selectedCustomer.accountNo])

  return isLoading ? (
    <div className={classes.loader}>
      <CircularProgress
        size={30}
        thickness={5}
      />
    </div>
  ) : (
    <DetailedItemTemplate
      isLoading={isLoading}
      item={itemDetails}
    />
  )
}
